import { Client } from "@xmpp/client"
import XmppVCardApi from "../api/xmppVCardApi"
import { selectWhatsappRosterItem } from "./rosterSelectors"
import { AppDispatch, RootState } from "./store"
import { Roster } from "./rosterSlice"
import {
  AnyAction,
  ListenerEffectAPI,
  PayloadAction,
  ThunkDispatch,
} from "@reduxjs/toolkit"
import { upsertProfile } from "./profilesSlice"

export const getWhatsappStatus = (client: Client) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    const whatsappRosterItem = selectWhatsappRosterItem(getState())

    if (!whatsappRosterItem) {
      return undefined
    }

    const vcard = await XmppVCardApi.fetchVCard(client, whatsappRosterItem.jid)

    return vcard?.description
  }
}

export const refreshVCards = async (
  action: PayloadAction<Roster>,
  listenerApi: ListenerEffectAPI<
    unknown,
    ThunkDispatch<unknown, unknown, AnyAction>,
    unknown
  >,
) => {
  const { items } = action.payload
  const client = window.XMPP
  if (client) {
    for (const item of items) {
      if (item.groups && item.groups.includes("Rest")) {
        const vcard = await XmppVCardApi.fetchVCard(client, item.jid)
        if (vcard) {
          listenerApi.dispatch(upsertProfile({ profile: vcard }))
        }
      }
    }
  }
}
